import { buildFields } from 'ra-data-hasura';
// import { HttpError } from 'react-admin';
import gql from 'graphql-tag';

/**
 * Extracts just the fields from a GraphQL AST.
 * @param {GraphQL AST} queryAst
 */
export const extractFieldsFromQuery = (queryAst: any) => {
  return queryAst.definitions[0].selectionSet.selections;
};

// Define the additional fields that we want.
const EXTENDED_GET_LIST_PLATFORMS = gql`
  {
    Financings_aggregate {
      aggregate {
        count
      }
    }
  }
  `;

const EXTENDED_GET_LIST_MERCHANTS = gql`
  {
    Financings_aggregate {
      aggregate {
        count
      }
    }
  }
  `;

const EXTENDED_GET_LIST_MERCHANTSV2 = gql`
  {
    financings_aggregate {
      aggregate {
        count
      }
    }
  }
  `;


const EXTENDED_GET_ONE_OFFER = gql`
  {
    financings {
      id
    }
  }
  `;


const EXTENDED_GET_ONE_MERCHANT = gql`
    {
      Financings(order_by: {id: desc}, limit: 1) {
        amount
        country
        created_at
        currency
        fixed_fee
        id
        merchant_id
        repayment_rate
        updated_at
        limit_date
        financing_date
        Transactions_aggregate(where: {type: {_in: ["REPAYMENT","DIRECT_PAYMENT"]}}) {
          aggregate {
            sum {
              value
            }
          }
        }
      }
      FinancialRegimen {
          data
          description
          id
          name
      }
    }
  `;


const EXTENDED_GET_LIST_TRANSACTIONS = gql`
  {
    collections: ConciliationTransactions_aggregate {
      aggregate {
        sum {
          balance
          expected_deposit
          actual_deposit
          gross_sales
          repayment
        }
      }
    }
  }

  `


const customBuildFields = (type: { name: any; }, fetchType: string) => {
  const resourceName = type.name;
  // console.log(type)
  // First take the default fields (all, but no related or nested).
  const defaultFields = buildFields(type, fetchType);

  if (resourceName === 'Platform' && fetchType === 'GET_LIST') {
    const relatedEntities = extractFieldsFromQuery(EXTENDED_GET_LIST_PLATFORMS);
    defaultFields.push(...relatedEntities);
  } else if (resourceName === 'Merchant' && fetchType === 'GET_LIST') {
    const relatedEntities = extractFieldsFromQuery(EXTENDED_GET_LIST_MERCHANTS);
    defaultFields.push(...relatedEntities);
  } else if (resourceName === 'Transaction' && fetchType === 'GET_LIST') {
    const relatedEntities = extractFieldsFromQuery(EXTENDED_GET_LIST_TRANSACTIONS);
    defaultFields.push(...relatedEntities);
  } else if (resourceName === 'merchants' && fetchType === 'GET_LIST') {
    const relatedEntities = extractFieldsFromQuery(EXTENDED_GET_LIST_MERCHANTSV2);
    defaultFields.push(...relatedEntities);
  } else if (resourceName === 'Merchant' && fetchType === 'GET_ONE') {
    const relatedEntities = extractFieldsFromQuery(EXTENDED_GET_ONE_MERCHANT);
    defaultFields.push(...relatedEntities);
    // Extend other queries for other resources/fetchTypes here...
  } else if (resourceName === 'offers' && fetchType === 'GET_ONE') {
    const relatedEntities = extractFieldsFromQuery(EXTENDED_GET_ONE_OFFER);
    defaultFields.push(...relatedEntities);
  }

  return defaultFields;
};

export default customBuildFields